<template>
	<c-dialog ref="dialog" mode="slide" width="50vw" mask-close >
		<div class="m-dialog-body">
		<!-- 基本信息 -->
		<div class="m-form-row">
			<div class="m-form-item">
				<label class="m-label"><span class="m-required">*</span> 借货人</label>
				<div class="m-select-wrap">
					<c-select ref="borrowerSelect" v-model="borrowerId" async @search="searchBorrower" placeholder="请选择" style="flex: 1;"></c-select>
					<span class="m-link" @click="createCustomer">
						<i class="tf-add"></i> 新建客户
					</span>
				</div>
			</div>
			<div class="m-form-item">
				<label class="m-label">备注</label>
				<c-input v-model="remark" placeholder="请输入备注" maxlength="200"></c-input>
			</div>
		</div>
         <c-title>商品明细</c-title>
		<!-- 商品明细 -->
		<div class="m-detail-card flex-column">
			<div class="m-toolbar flex-center-cross">
				<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanHandle" style="width:200px;"></c-input>
				<c-button color="main" @click="scanHandle">确定</c-button>
				<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
			</div>
			<c-table ref="list" :data="productList" :paging="false" @dataChange="selectChange">
				<template #empty>
					<div class="m-empty-state">
						<div class="m-empty-icon">
							<svg viewBox="0 0 64 64" width="64" height="64">
								<rect x="8" y="18" width="48" height="28" rx="4" fill="none" stroke="currentColor" stroke-width="3"/>
								<line x1="16" y1="26" x2="16" y2="38" stroke="currentColor" stroke-width="3"/>
								<line x1="24" y1="24" x2="24" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="32" y1="24" x2="32" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="40" y1="24" x2="40" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="48" y1="26" x2="48" y2="38" stroke="currentColor" stroke-width="3"/>
								<line x1="8" y1="32" x2="56" y2="32" stroke="currentColor" stroke-width="2" stroke-dasharray="3,3"/>
							</svg>
						</div>
						<p>请扫描产品背贴码</p>
					</div>
				</template>

				<c-table-column type="selector" width="40"></c-table-column>
				<c-table-column label="产品信息" width="300">
					<template #default="{data}">
                        <c-state dict="LEVEL_TYPE" tag :value="data.level_type"></c-state>
						<span>{{data.product_info || getProductText(data)}}</span>
					</template>
				</c-table-column>
				<c-table-column label="背贴码" width="140">
					<template #default="{data}">{{data.produce_unique_code || '-'}}</template>
				</c-table-column>
				<c-table-column label="IMEI" width="150">
					<template #default="{data}">{{data.produce_imei || '-'}}</template>
				</c-table-column>
				<c-table-column label="成本价" width="90">
					<template #default="{data}">{{data.cost_price ? '¥' + data.cost_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="* 同行价" width="140">
					<template #default="{data}">
						<div class="m-price-input-wrap flex-center-cross">
							<c-input type="number" decimal="2" :range="[0, 99999999]" :value="data.market_price" @input="onPriceInput(data, $event)" placeholder="请输入" append-text="元"></c-input>
						</div>
					</template>
				</c-table-column>
				<c-table-column label="操作" width="80" type="button">
					<template #default="{data}">
						<c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</div>
		</div>

		<!-- 底部按钮 -->
		<template #button>
			<c-button size="dialog" color="main" :disabled="!productList.length" @click="submitHandle">确认借出</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import CState from "@/components/public/state.vue";

    export default {
		name: 'saleLendEdit',
        components: {CState},

		data() {
			return {
				borrowerId: '',
				remark: '',
				scanCode: '',
				productList: [],
				selectedList: []
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.borrowerId = '';
				this.remark = '';
				this.scanCode = '';
				this.productList = [];
				this.selectedList = [];
				this.$refs.dialog.open({title: '新建借出'});
				if (data && data.codes && data.codes.length) {
					/**商品管理列表快捷借出：按背贴码批量预填明细，走与手工扫码相同的后端校验*/
					this.loadByCodes(data.codes);
				} else {
					this.focusInput();
				}
			},

			/*********按背贴码批量加载商品明细（用于列表快捷借出）**********/
			loadByCodes(codes) {
				var list = codes || [];
				var index = 0;
				var next = () => {
					if (index >= list.length) {
						this.focusInput();
						return;
					}
					var code = list[index++];
					if (this.productList.some(item => item.produce_unique_code == code)) {
						next();
						return;
					}
					this.request({
						url: '/productCode/queryByCode',
						data: {produce_unique_code: code, query_type: 'lend'},
						success: (data) => {
							//同行价默认带出小黑靓机标价，未取到时为空由借出人自行填写
							this.$set(data, 'market_price', data.channel_sale_price || '');
							this.productList.push(data);
							next();
						},
						fail: (msg) => {
							this.$message({message: '背贴码【' + code + '】' + (msg || '加载失败'), type: 'warn'});
							next();
						}
					});
				};
				next();
			},

			/*********聚焦输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********搜索借货人**********/
			searchBorrower(keyword, resolve) {
                this.request({
                    url:'/sale/customer/options',
                    data: {
                        keyword:keyword,
                        //借出只可选同行客户
                        customer_type: 1
                    },
                    success:data => {
                        resolve((data || []).map(item => {
                            return {
                                name: item.customer_name,
                                value: item.id
                            };
                        }));
                    }
                })
			},

			/*********新建客户**********/
			createCustomer() {
				//指定新建的客户固定为同行客户
				this.globalDialog('saleCustomerEdit', {
					props: {
						customer_type: 1
					}
				}, () => {
					// 刷新借货人下拉
					if (this.$refs.borrowerSelect) {
						this.$refs.borrowerSelect.search('');
					}
				});
			},

			/*********扫码处理**********/
			scanHandle() {
				var code = this.scanCode.trim();
				if (!code) {
					this.$message({message: '请输入背贴码', type: 'warn'});
					return;
				}
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({message: '该背贴码已添加', type: 'warn'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				this.request({
					url: '/productCode/queryByCode',
					data: {produce_unique_code: code, query_type: 'lend'},
					loading: true,
					success: (data) => {
						//同行价默认带出小黑靓机标价，未取到时为空由借出人自行填写
						this.$set(data, 'market_price', data.channel_sale_price || '');
						this.productList.push(data);
						this.scanCode = '';
						this.focusInput();
					},
					fail: (msg) => {
						this.$message({message: msg, type: 'warn'});
						this.scanCode = '';
						this.focusInput();
					}
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********选中变化**********/
			selectChange() {
				this.selectedList = this.$refs.list.getData('selected');
			},

			/*********移除单项**********/
			removeItem(data) {
				this.productList = this.productList.filter(item => item.id != data.id);
				this.focusInput();
			},

			/*********批量移除**********/
			batchRemove() {
				if (!this.selectedList.length) {
					this.$message({message: '请先勾选要移除的记录', type: 'warn'});
					return;
				}
				var ids = this.selectedList.map(item => item.id);
				this.productList = this.productList.filter(item => !ids.includes(item.id));
				this.selectedList = [];
				this.focusInput();
			},

			/*********同行价输入**********/
			onPriceInput(data, val) {
				var item = this.productList.find(item => item.id == data.id);
				if (item) this.$set(item, 'market_price', val);
			},

			/*********提交借出**********/
			submitHandle() {
				if (!this.borrowerId) {
					this.$message({message: '请选择借货人', type: 'warn'});
					return;
				}
				if (!this.productList.length) {
					this.$message({message: '请至少添加一个商品', type: 'warn'});
					return;
				}
				var invalidItems = this.productList.filter(item => {
					var val = item.market_price;
					if (val === undefined || val === null || val === '') return true;
					var price = Number(val);
					return isNaN(price) || price < 0;
				});
				if (invalidItems.length) {
					this.$message({message: '请填写所有商品的同行价', type: 'warn'});
					return;
				}
				this.request({
					url: '/sale/lend/create',
					data: {
						borrower_id: this.borrowerId,
						product_list: this.productList.map(item => ({
							produce_unique_code_id: item.id,
							market_price: parseFloat(item.market_price)
						})),
						remark: this.remark
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '借出成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-dialog-body {
		padding: 0 20px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}

	.m-form-row {
		display: flex;
		align-items: flex-start;
		gap: 40px;
		margin-bottom: 16px;
		margin-top: 16px;
	}

	.m-form-item {
		flex: 1;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		.m-select-wrap {
			display: flex;
			align-items: center;
			gap: 8px;

			.m-link {
				flex-shrink: 0;
				font-size: 13px;
				color: #1890ff;
				cursor: pointer;
				white-space: nowrap;

				i {
					margin-right: 2px;
				}

				&:hover {
					color: #40a9ff;
				}
			}
		}
	}

	.m-detail-card {
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
	}

	.m-section-title {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		border-bottom: 1px solid #e8e8e8;

		.m-title-icon {
			width: 4px;
			height: 16px;
			background: #1890ff;
			border-radius: 2px;
			margin-right: 8px;
		}

		.c-title {
			margin: 0;
		}
	}

	.m-toolbar {
		padding: 10px 16px;
		background: #fafafa;
		border-bottom: 1px solid #e8e8e8;
		gap: 10px;

		.m-scan-input-box {
			position: relative;
			width: 150px;

			/deep/ .c-input input {
				background: #fffbe6;
				padding-right: 32px;
			}

			.m-scan-icon {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				color: #999;
				cursor: pointer;
			}
		}
	}

	.m-empty-state {
		padding: 60px 0;
		text-align: center;
		color: #999;

		.m-empty-icon {
			color: #ccc;
		}

		p {
			margin-top: 10px;
			font-size: 14px;
		}
	}

	.m-tag {
		display: inline-block;
		padding: 1px 6px;
		font-size: 12px;
		border-radius: 3px;
		margin-right: 4px;
	}

	.m-tag-green {
		color: #52c41a;
		background: #f6ffed;
		border: 1px solid #b7eb8f;
	}

	.m-tag-blue {
		color: #1890ff;
		background: #e6f7ff;
		border: 1px solid #91d5ff;
	}

	.m-tag-purple {
		color: #722ed1;
		background: #f9f0ff;
		border: 1px solid #d3adf7;
	}

	.m-tag-orange {
		color: #fa8c16;
		background: #fff7e6;
		border: 1px solid #ffd591;
	}

	.m-tag-red {
		color: #f5222d;
		background: #fff1f0;
		border: 1px solid #ffa39e;
	}

	.m-price-input-wrap {
		/deep/ .c-input {
			width: 100%;
		}
	}
</style>
